<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame" id="_idContainer012">
<p class="basic-paragraph"><span class="charoverride4"><br class="calibre1"/></span></p>
<h1 class="basic-paragraph"><span class="charoverride4">Dedication</span></h1>
<p class="basic-paragraph"><span class="charoverride5"><br class="calibre1"/></span></p>
<p class="basic-paragraph"><span class="charoverride5">This one is for Robert Reynolds, my father-in-law,</span></p>
<p class="basic-paragraph"><span class="charoverride5">who once told me that he always looks forward to the next Red River novel </span></p>
<p class="basic-paragraph"><span class="charoverride5">so he can catch up with the Parkers who are like family.</span></p>
<p class="basic-paragraph"><span class="charoverride5">You can’t ask for a better endorsement than that.</span></p>
<p class="basic-paragraph"><span class="charoverride5">Thanks for everything, Grandpa.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?58290483